import React from 'react'; //eslint-disable-line

const GoLogo = () => {
  return (
    <svg viewBox="-1 -1 68 33" id="logo-go">
      <path d="M50.5 0A15.56 15.56 0 0035 14h31A15.56 15.56 0 0050.5 0zM0 15.5A15.526 15.526 0 0014 31V0A15.526 15.526 0 000 15.5zM17 0v14h14A15.7 15.7 0 0017 0zm33.5 31A15.583 15.583 0 0066 17H35a15.583 15.583 0 0015.5 14zM17 31h14V17H17v14z"></path>
    </svg>
  );
};

export default GoLogo;

